export default __webpack_public_path__ + "static/media/trash-icon-black.4949e862.svg";